import React, { FC } from 'react';

import { PROGRESS_BAR_DEFAULTS } from 'views/OfferDesign/OfferDesign.consts';

import { ColorPicker } from 'components/ui/ColorPicker/color-picker';

import { GradientFieldConfig, UploadFieldConfig } from '../../FormFields.types';
import {
  FormFieldsColorRow,
  FormFieldsNumberRow,
  FormFieldsSection,
  FormFieldsUploadSection
} from '../../components';

import { useFormFieldsContext } from '../../../../context';

import { BAR_FILL_COLOR_FIELD, BAR_NUMBER_FIELDS } from '../ProgressBarFormFields.consts';

interface IProgressBarDesignSectionProps {
  gradientFields: GradientFieldConfig[];
  uploadFields: UploadFieldConfig[];
}

export const ProgressBarDesignSection: FC<IProgressBarDesignSectionProps> = ({
  gradientFields,
  uploadFields
}): React.ReactElement => {
  const { values, setFieldValue } = useFormFieldsContext();

  return (
    <FormFieldsSection
      heading="Progress Bar Design"
      description="Set colors and upload assets for your bar."
      showSeparator
    >
      <div className="flex gap-5">
        <div className="flex-1">
          <ColorPicker
            label="Font Color"
            infoTooltipContent="Applies to all text in the Progress Bar."
            data-testid="offer-design-progress-bar-font-color-input"
            defaultValue={values.textColor || PROGRESS_BAR_DEFAULTS.textColor}
            onChange={(color) => setFieldValue('textColor', color)}
          />
        </div>
        <FormFieldsColorRow fields={[BAR_FILL_COLOR_FIELD]} layout="flex" />
      </div>

      <FormFieldsColorRow fields={gradientFields} spacing="sm" />

      <FormFieldsNumberRow fields={BAR_NUMBER_FIELDS} spacing="sm" />

      <FormFieldsUploadSection fields={uploadFields} spacing="lg" />
    </FormFieldsSection>
  );
};
